import Vue from 'vue';
import { MutationTree } from 'vuex';
import { FeatureState } from '@/store/features/types';

export const mutations: MutationTree<FeatureState> = {
  set(state: FeatureState, opts) {
    Vue.set(state, opts.type, opts.data);
  }
};
